<template>
  <div class="bp">
    <TopHead
      name="精选美图"
      :is-share="true"
      share-name="精选美图"
      share-text="精选美图"
      :share-img="picArr.length ? picArr[0].cover : ''"
    />
    <div class="pic_out">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in picArr"
          :key="index"
          class="swiper-slide cur_p p_r"
        >
          <van-image
            fit="cover"
            :src="item.cover"
          />
          <div class="bp_name">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import '../../public/swiper/swiper.min.css';
  import  Swiper from '../../public/swiper/swiper.min.js';
  import url from  '../assets/img/h_bg.png'
  export default {
    data() {
      return {
        src:url,
        picArr:[],
        params:{
          pageIndex:1,
          pageSize:100,
          data:{},
        }
      }
    },
    created() {
    },
    mounted(){
      this.getByTypeCodeSellers();
    },
    methods: {
      getByTypeCodeSellers(){
        let _t = this;
        _t.$api.getByTypeCodeSellers(_t.params).then(res => {
          _t.picArr = res.data.rows;
          setTimeout(function () {
            _t.bpSwiper()
          },500)
        })
      },
      //轮播
      bpSwiper(){
        this.$nextTick(() => {
          let pic_out = new Swiper('.pic_out', {
            slidesPerView: 1.3,
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
            freeMode: false,
          });
        });
      },
    }
  }
</script>

<style lang="scss">
  .pic_out{
    .swiper-slide{
      &.swiper-slide-prev,&.swiper-slide-next{
        transform: scale(0.9);
      }
      .bp_name{
        font-size: 32px;
        font-weight: bold;
        color: #3E3E3E;
        line-height: 112px;
        padding-left: 34px;
      }
      .van-image{
        height: 828px;
      }
      background: #FFFFFF;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      overflow: hidden;
    }
    margin-top: 69px;
  }
  .bp{
    background-color: #f5f5f5;
    padding-top: 85px;
    box-sizing: border-box;
    height: 100vh;
    overflow: auto;
  }

</style>

